import i18n from 'live/services/i18n'
export const requiredField = i18n('Required field')
export const invalidField = i18n('Invalid value')